import { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import BannerSingle from '../../../BannerSingle';
import PageDescriptionPlano from '../../../PageDescription/Planos/index';
import Lgpd from '../../../Lgpd';
import PatrimonioPlano from '../../../Numeros/Planos';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import Helper from "../../../Helper";

interface ComponentProps {
	page?: string;
}

interface ComponentState {
	isLoaded: boolean;
	result: any[];
}

class DescricaoPage extends Component<ComponentProps, ComponentState> {

	private helper: Helper;

	constructor(props: ComponentProps) {
		super(props);
		this.state = {
			isLoaded: false,
			result: []
		};
		this.helper = new Helper(this);
	}

	componentDidMount() {
		this.helper.init('plano-b');
	}

	componentDidUpdate(prevProps: ComponentProps, prevState: ComponentState) {
		if (this.state.result.length > 0 && prevState.result !== this.state.result) {
			document.title = this.state.result[0]?.Title;
		}
	}

	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					<ErrorBoundary><BannerSingle image={"plano-b"} page={'plano-b'} items={this.state.result}/></ErrorBoundary>
					{/* Page description */}
					<ErrorBoundary><PageDescriptionPlano certificado={"/DOCS/Publicacoes/Certificados/Plano%20B/Certificado%20do%20Participante%20-%20Plano%20B.pdf"}  page={'plano-b'} items={this.state.result}/></ErrorBoundary>

					{/* Content page */}
					<ErrorBoundary><PatrimonioPlano url={"/ObterDescricaoPlanoB"} urlTable={"/ObterDescricaoPlanoB"}  page={'plano-b'} items={this.state.result}/></ErrorBoundary>
					

				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default DescricaoPage;